import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import route from '@configs/routes.json';
import { ClinicalReportStatus } from '@models';
import { BaseCellProps } from '@components/TableCells/helpers/CellHelpers';

import { getInactiveReportStatuses } from '../../helpers/results-package-helper';
import './ReportIDCell.scss';
interface InactiveReportURLParams {
  patientId: string;
  sampleName: string;
  specimenNumber: string;
}
interface ReportIDCellProps extends BaseCellProps {
  value: string;
  reportStatus: ClinicalReportStatus;
  hasActiveReport: boolean;
  urlParams: InactiveReportURLParams;
}

const ReportIDCell: React.FC<ReportIDCellProps> = ({
  value,
  reportStatus,
  hasActiveReport,
  urlParams,
}) => {
  const { t } = useTranslation();
  const inactiveReportObj = getInactiveReportStatuses(
    reportStatus,
    hasActiveReport
  );

  const inactiveCmp = inactiveReportObj.isInactiveReport ? (
    <div className='d-flex flex-row align-items-center inactive-report-container'>
      <div className='text'>
        {`(${t(
          inactiveReportObj.isObsoleteReport
            ? 'downloadResultsPkg_summaryTable_reportIdObsolete'
            : 'downloadResultsPkg_summaryTable_reportIdOutdated'
        )})`}
      </div>
      <Link
        to={`${route.app.results}?${
          inactiveReportObj.isObsoleteReport
            ? 'externalSubjectId=' + encodeURIComponent(urlParams.patientId)
            : `sampleName=${encodeURIComponent(
                urlParams.sampleName
              )}&specimenNumber=${encodeURIComponent(urlParams.specimenNumber)}`
        }`}
        className='d-flex p-0 flex-row btn btn-sm btn-link flex-shrink-0 align-items-center fcolor--primary-brand-text'
      >
        <span className='pr-1'>
          {t(
            inactiveReportObj.isObsoleteReport
              ? 'downloadResultsPkg_summaryTable_reportIdObsoleteLink'
              : 'downloadResultsPkg_summaryTable_reportIdOutdatedLink'
          )}
        </span>
        <i className='fas fa-chevron-right'></i>
      </Link>
    </div>
  ) : null;
  return (
    <td className='reportid-cell'>
      <div className='d-flex flex-row align-items-center'>
        <div>{value}</div>
        {inactiveCmp}
      </div>
    </td>
  );
};

export default ReportIDCell;
